import { t } from 'i18next';

const Copyright = () => {
  const currentYear = new Date().getFullYear();

  return (
    <span className="text-xs">
      © {currentYear} SonicFi Inc. {t('footer.allRightsReserved')}.
    </span>
  );
};

export default Copyright;
